/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

// Material UI
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import Avatar from '@material-ui/core/Avatar';

// Styles
import useStyles from './ListSkeleton.styles';

interface ListSkeletonInterface {
  generateCount?: number;
  width?: number;
  height?: number;
}

type Props = ListSkeletonInterface;

const ListSkeleton: React.FC<Props> = ({
  generateCount = 1,
  width,
  height,
}) => {
  const classes = useStyles();

  return (
    <Grid item alignItems='center'>
      {Array.from({ length: generateCount }).map((s: any, i) => (
        <Box display='flex' alignItems='center'>
          <Box width='100%'>
            <Skeleton width='100%'>
              <Typography>.</Typography>
            </Skeleton>
          </Box>
          <Box margin={1}>
            <Skeleton variant='circle'>
              <Avatar style={{ width, height }} />
            </Skeleton>
          </Box>
        </Box>
      ))}
    </Grid>
  );
};

export default ListSkeleton;
export { ListSkeleton };
